const DEFAULT_GOOGLE_STATIC_MAP = {
  LAT: 47.6072514,
  LON: -122.3387425,
  ZOOM_LEVEL: 17,
};

// please preserve the order of this object
const PDP_HEADER_TAB_LABEL = {
  LISTING: 'listing',
  MESSAGES: 'messages',
  APPLICATIONS: 'applications',
  LEASES: 'leases',
  PAYMENTS: 'payments',
  ANALYTICS: 'analytics',
  REVIEWS: 'reviews',
};

const TAB_PATHS = {
  listing: '/rental-manager/properties/:propertyId/listing',
  messages: '/rental-manager/inbox/:propertyId?byProperty=true',
  applications: '/rental-manager/applications?propertyId=:propertyId',
  leases: '/rental-manager/leasing/property/:propertyId',
  payments: '/rental-manager/payments/properties/:propertyId',
  analytics: '/rental-manager/properties/:propertyId/analytics',
  reviews: '/rental-manager/properties/:propertyId/reviews',
};

interface BreadcrumbPaths {
  [key: string]: string;
}

const BREADCRUMB_PATHS: BreadcrumbPaths = {
  [PDP_HEADER_TAB_LABEL.APPLICATIONS]: '/rental-manager/properties/:listingAlias/dashboard/overview',
  [PDP_HEADER_TAB_LABEL.LEASES]: '/rental-manager/properties/:listingAlias/dashboard/overview',
  [PDP_HEADER_TAB_LABEL.LISTING]: '/rental-manager/properties/:listingAlias/dashboard/overview',
  [PDP_HEADER_TAB_LABEL.PAYMENTS]: '/rental-manager/properties/:listingAlias/dashboard/overview',
};

export { BREADCRUMB_PATHS, DEFAULT_GOOGLE_STATIC_MAP, PDP_HEADER_TAB_LABEL, TAB_PATHS };
